import {Injectable} from '@angular/core';
import {ApiUrlConstants} from '@coreconstant';
import {HttpService} from '../http-service/http.service';
import {RequestParamModel} from '../../models/request-param-model';
import {map} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {PaginationModal} from '../../models/pagination-modal';

@Injectable({
    providedIn: 'root'
})
export class VenueAccommodationService {

    baseUrlApi = ApiUrlConstants.VENUE_ACCOMMODATION_BASE_URL;

    constructor(
        private _httpService: HttpService
    ) {
    }

    /**
     * Retrieves accommodations for a venue based on the provided input parameters.
     * @param {RequestParamModel} [input] - Optional input parameters for filtering the accommodations request.
     */
    getVenueAccommodations(input?: RequestParamModel) {
        return this._httpService.get(
            {
                url: this.baseUrlApi,
                filterParameters: input
            })
            .pipe(
                map((response: HttpResponse<any>) => {
                    const stateList = new PaginationModal<any>();
                    const headers = response.headers;
                    stateList.setHeaders(headers);
                    stateList.data = response.body.data as any[];
                    return stateList;
                }, (err: any) => {
                    return err;
                })
            );
    }
}
